.dialog-header-title {
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
  color: #ffffff;
}

@media screen and (min-width: 980px) {
  .dialog-header-title {
    font-size: 22px;
    line-height: 32px;
  }

  :host(:not([dir="rtl"])) .dialog-header-title {
    padding-left: 25px;
  }

  :host([dir="rtl"]) .dialog-header-title {
    padding-right: 25px;
  }
}